

























import { computed, defineComponent, ref } from '@vue/composition-api';

const Modal = defineComponent({
  props: {
    direction: { default: () => 'left' },
    title: { default: '' },
  },
  setup(props, { emit }) {
    const internalOpen = ref(false);
    function open() {
      internalOpen.value = true;
    }

    function close() {
      internalOpen.value = false;
      emit('closed', 'reset');
    }

    function pendingClose(force = false) {
      emit('close');
      close();
    }

    return {
      internalOpen,
      open,
      close,
      pendingClose,
    };
  },
});

export default Modal;
